import { api } from '@/services/apiClient'

export const sendReport = async (payload: {
  screenshot: string
  comment: string
  url: string
  user_agent: string
}): Promise<any> => {
  const { data } = await api.post<any>('/report/feedback', payload)
  return data
}
